/* eslint-disable */
import React from 'react';
// import PropTypes from 'prop-types';
// import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import GridItem from "components/Grid/GridItem.jsx";
// import GridContainer from "components/Grid/GridContainer.jsx";

// core components
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

// @material-ui/icons
import Payment from "@material-ui/icons/Style";
import Settlement from "@material-ui/icons/DoneAll";
import { primaryColor } from "assets/jss/material-dashboard-react.jsx";
import Faan from 'assets/img/faan_logo.png';
import { Link } from 'react-router-dom';
import "../landing.css"
import {appConstants} from "../../../_constants";
import Authorization from "../component/Authorization";
import Money from "@material-ui/icons/Money"

const MyComponent = ({classes, user, styles, setView}) => {
    const props_ = {
        styles: styles,
        user: user,
        classes: classes,
        setView: setView
    };
    
    return (
        <div className={`root ${classes.root}`}>
            <div className={classes.rootOverlay}>

                <Authorization {...props_}/>

                <Grid container className={classes.center2}>
                    <Grid item lg={6} sm={12}>
                        <div style={{ margin: '15px 0 20px' }}><img src={Faan} /></div>
                    </Grid>
                </Grid>
                <Grid container className={classes.center2} style={{ paddingTop: '0', textAlign: 'center'}}>
                    <GridItem container lg={10} sm={12}>
                        <Grid container>
                                <Grid item lg={
                                    (user.AppRole !== appConstants.ROLES.AIRLINE) ? 4 : 6} sm={12}
                                      className={classes.card}>
                                    <Grid direction="row"
                                          justify="center"
                                          alignItems="center">
                                        <Card chart>
                                            <Link to={setView === "regional" ? "app/psc-regional/airline-payment" : "app/airline-payment"} className={'animate-card-container'}>
                                                <CardHeader color="warning" className={'animate-card-header'}>
                                                    <div style={{textAlign: "center", margin: "0"}}>
                                                        <Payment style={{fontSize: "60px"}}/>
                                                    </div>
                                                    <h4 style={styles.title}>Airline Payment </h4>
                                                </CardHeader>
                                                <CardBody>
                                                    <p style={{color: '#000'}}>
                                                        Tokens purchased by airlines in real-time.
                                                    </p>
                                                    <Button
                                                        type="button"
                                                        color="warning"
                                                        // style={{background: '#23c3d6'}}
                                                    >
                                                        Explore
                                                    </Button>
                                                </CardBody>
                                            </Link>
                                        </Card>
                                    </Grid>
                                </Grid>
                                <Grid item lg={
                                    (user.AppRole !== appConstants.ROLES.AIRLINE) ? 4 : 6} sm={12} className={classes.card}>
                                    <Card chart>
                                        <Link to={setView === "regional" ? "app/psc-regional/psc-settlement" : "app/psc-settlement"} className={'animate-card-container'}>
                                            <CardHeader color="info" className={'animate-card-header'}>
                                                <div style={{ textAlign: "center", margin: "0" }}>
                                                    <Settlement style={{ fontSize: "60px" }} />
                                                </div>
                                                <h4 style={styles.title}>PSC Settlement </h4>
                                            </CardHeader>
                                            <CardBody>
                                                <p style={{ color: '#000' }}>
                                                    Module reconciles flown passenger with tokens purchased
                                                </p>
                                                <Button
                                                    type="button"
                                                    color="info"
                                                >
                                                    Explore
                                                </Button>
                                            </CardBody>
                                        </Link>
                                    </Card>
                                </Grid>
                                <Grid item lg={4} sm={12} className={classes.card}>
                                    <Grid direction="row"
                                          justify="center"
                                          alignItems="center">
                                        <Card chart>
                                            <Link to={setView === "regional" ? "app/psc-regional/statement-of-account" : "app/statement-of-account"} className={'animate-card-container'}>
                                                <CardHeader color={setView === "regional" ? "regional" : "success"} className={'animate-card-header'}>
                                                    <div style={{ textAlign: "center", margin: "0" }}>
                                                        <Money style={{ fontSize: "60px" }} />
                                                    </div>
                                                    <h4 style={styles.title}>Statement Of Account</h4>
                                                </CardHeader>
                                                <CardBody>
                                                    <p style={{ color: '#000' }}>
                                                        Account details.
                                                    </p>
                                                    <Button
                                                        type="button"
                                                        color={setView === "regional" ? "regional" : "success"}
                                                    >
                                                        Explore
                                                    </Button>
                                                </CardBody>
                                            </Link>
                                        </Card>
                                    </Grid>
                                </Grid>
                        </Grid>
                    </GridItem>

                </Grid>
            </div>
        </div >
    );
};

export default MyComponent;



// WEBPACK FOOTER //
// ./src/layouts/Landing/roles/creditControl.js